export default [
  { path: '/main/upgrade', name: 'MainUpgrade', component: () => import(/* webpackChunkName: "main-upgrade" */ './index.vue') }
]